import React from 'react';
import './AuthCallbackLoading.css';

const AuthCallbackLoading = () => {
  return (
    <div className="auth-callback-loading" role="status" aria-live="polite">
      <div className="auth-callback-spinner" aria-hidden="true" />
      <p className="auth-callback-title">Signing you in...</p>
      <p className="auth-callback-subtitle">
        Finalizing your account and syncing your coin balance.
      </p>
    </div>
  );
};

export default AuthCallbackLoading;
